import { useHttp } from '../http'

export interface BubbleAllowance {
    allowance: {
        plan: 'free' | 'premium'
        credits_total: number
        credits_used: number
        credits_left: number
        resets_at: string
        questions_asked: number
    }
    plan_credits: number
    granted_credits: number
    period: string
    timezone: string
    grants: Array<{ id: number, credits: number, note: string | null, granted_by: string | null, created_at: string }>
}

// SSO-3623: a swimmer's Bubble credits this month, and extra credits for it.
export const useUserBubbleAllowanceHttp = (userId: number) => {

    const get = (): Promise<BubbleAllowance> => {
        return useHttp().get(`users/${userId}/bubble-allowance`)
    }

    const grant = (payload: { credits: number, note?: string }): Promise<BubbleAllowance> => {
        return useHttp().post(`users/${userId}/bubble-allowance/grants`, payload)
    }

    return {
        get,
        grant,
    }
}
